import React, { Component } from 'react';
import { Link, Redirect } from 'react-router-dom';

class Congrats extends Component {
    state = {  }
    render() { 
        return ( 
            <div className="full-div">
                <div className="hero-min">
                    <div className="spacer"></div>
                    <div className="hero-min-topic">
                        <h2>Congratulations {this.nameUser()}</h2>
                        <p>
                            . <br/><br/><br/>
                        </p>
                    </div>
                </div>
                <div className="hero-align un-margin-new row">
                    <div className="col-md-6">
                        <div className="inner-align-new">
                            <p>
                                You have successfully registered. Please download the mobile app to begin your amazing experience with towva 
                            </p>
                            <div className="cat-sect">
                                <div className="cat-downloads">
                                    <div data-aos="zoom-in" data-aos-delay="1000">
                                    <a href="https://portal.towva.co/user_app"><img src={require("./../images/play-store.png")} width="100%" alt=""/></a>
                                    </div>
                                    <div></div>
                                    <div data-aos="zoom-in" data-aos-delay="1200">
                                        <a href="https://portal.towva.co/user_app"><img src={require("./../images/app-store.png")} width="100%" alt=""/></a>
                                    </div>
                                </div>
                                <Link to="/"><button  data-aos="fade-up" data-aos-delay="1600">Back to home</button></Link>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-6" data-aos="zoom-in">
                        <div className="hero-image">
                            <img src={require("./../images/congrats.png")} width="100%" alt=""/>
                        </div>
                    </div>
                </div>
            </div>
         );
    }
    componentDidMount(){
        window.scrollTo(0, 0)
    }
    nameUser = ()=>{
        if(sessionStorage.getItem('name2')){
            const name = sessionStorage.getItem('name2');
            sessionStorage.removeItem('name2');
            return ` ${name}`
        }else{
            return <Redirect to='/' />;
        }
    }
}
 
export default Congrats;